// material-ui
import {} from '@mui/material'

// assets

import AnonymousSignin from 'components/AnonymousSignin'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main(subcomponent: any): any {
    return (() => {
      // great
      return <AnonymousSignin />
    })()
  }

  let output_main = main(null)

  return output_main
}
